import React from 'react';
import { matchPath } from 'react-router';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Consumer } from './RoutesAllowlistProvider';

const AllowlistedLink = (props) => {
    const { children, ...rest } = props;

    return (
        <Consumer>
            {(routes) => {
                const inAllowlist = matchAllowlistPath(props.to, routes);
                return inAllowlist ? (
                    <Link {...rest}>{children}</Link>
                ) : (
                    <Link target="_self" {...rest}>
                        {children}
                    </Link>
                );
            }}
        </Consumer>
    );
};

const matchAllowlistPath = (to, routesAllowlist) => {
    const path = typeof to === 'string' ? to.replace(/\?.*/, '') : to.pathname;
    return (
        !routesAllowlist ||
        routesAllowlist.reduce((matching, route) => {
            const match = matchPath(path, { path: route, exact: true });
            return matching || match;
        }, false)
    );
};

AllowlistedLink.propTypes = {
    to: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.shape({
            pathname: PropTypes.string,
            search: PropTypes.string,
            hash: PropTypes.string,
            state: PropTypes.Object,
        }),
    ]),
    children: PropTypes.node,
    onClick: PropTypes.func,
};

export { AllowlistedLink, matchAllowlistPath };
